// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    FEATURED_SPONSORED_CARD_LOADING() {
      return {
        isLoading: true,
        featuredSponsoredCard: action.featuredSponsoredCard
      };
    },
    FEATURED_SPONSORED_CARD_LOADED() {
      return {
        isLoading: false,
        data: action.featuredSponsoredCard
      };
    },
    FEATURED_SPONSORED_CARD_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.featuredSponsoredCard.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
